import { render } from "./OutletType.vue?vue&type=template&id=1ff71661"
import script from "./OutletType.vue?vue&type=script&lang=js"
export * from "./OutletType.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__